module.exports = __webpack_public_path__ + "static/img/8497_phase_function_Paper_PointsHejduk_Prediction.295dabf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8497_phase_function_Paper_PointsHejduk_Prediction.png
// module id = tSh4
// module chunks = 0